import { render, staticRenderFns } from "./CreateTransactionView.vue?vue&type=template&id=5d66826c&"
import script from "./CreateTransactionView.vue?vue&type=script&lang=js&"
export * from "./CreateTransactionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports